import { Component } from '@angular/core';

@Component({
  selector: 'app-cards9-examples-60',
  templateUrl: './cards9-examples-60.component.html'
})
export class Cards9Examples60Component {}
